export var defaultTasksData = {
    'task-1': {
        taskId: 'task-1',
        taskName: 'Finish Ch 3',
        taskDescription: 'take notes and make flashcards',
    },
    'task-2': {
        taskId: 'task-2',
        taskName: 'Review Biology',
        taskDescription: 'review notes up until Chapter 5',
    },
    'task-3': {
        taskId: 'task-3',
        taskName: 'Hand In Report',
        taskDescription: 'edit a day before handing in',
    }
}

export var defaultWeekData = [
    {
        weekId: 0,
        weekTitle: 'Sun',
        weekName: 'Sunday',
        taskIds: ['task-1', 'task-2','task-3']
    },
    {
        weekId: 1,
        weekTitle: 'Mon',
        weekName: 'Monday',
        taskIds: []
    },
    {
        weekId: 2,
        weekTitle: 'Tue',
        weekName: 'Tueday',
        taskIds: []
    },
    {
        weekId: 3,
        weekTitle: 'Wed',
        weekName: 'Wednesday',
        taskIds: []
    },
    {
        weekId: 4,
        weekTitle: 'Thu',
        weekName: 'Thursday',
        taskIds: []
    },
    {
        weekId: 5,
        weekTitle: 'Fri',
        weekName: 'Friday',
        taskIds: []
    },
    {
        weekId: 6,
        weekTitle: 'Sat',
        weekName: 'Saturday',
        taskIds: []
    },
];

